import React from "react";
import { Box } from "@mui/material";
import { baseStyles, statusConfig } from "./styles";

const StatusBadge = ({ status }) => {
  const fallback = {
    text: status,
    style: {
      backgroundColor: "#EEE",
      color: "#555",
    },
  };

  const cfg = statusConfig[status] || fallback;

  return (
    <Box component="span" sx={{ ...baseStyles, ...cfg.style }}>
      {cfg.text}
    </Box>
  );
};

export default StatusBadge;
